import React from 'react'
import { Skeleton, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import ButtonSelector from '../../../Common/buttonSelector/ButtonSelector'
import PatientFormField from '../PatientFormField'
import { IdentityProofValue, PatientIdentityDocumentsProps } from './_props'
import { shouldDirty } from './_utils/_utils'
import { useFormContextPatient } from '../_utils'
import { useGetIdsReferencesIdentityproofs } from '@toktokdoctech/tokapi-client'

const PatientIdentityDocument = ({ onChange }: PatientIdentityDocumentsProps) => {
    const { control, setValue } = useFormContextPatient()

    const { data, isLoading: loading, error: identityProofError } = useGetIdsReferencesIdentityproofs()

    const documentsOption =
        data?.reduce<Array<{ label: string; value: IdentityProofValue }>>((acc, document) => {
            if (!document) {
                return acc
            }

            const value: IdentityProofValue = {
                __typename: 'IdentityProof',
                id: document.id,
                objectId: document.id,
                label: document.name,
                level: document.level,
                value: document.value,
            }

            acc.push({
                label: document.name,
                value,
            })
            return acc
        }, []) ?? []

    return (
        <Controller
            control={control}
            name="identityProof"
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="custom"
                    name={field.name}
                    label="Nature du justificatif d'identité"
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    render={() => (
                        <>
                            {loading && <Skeleton variant="rounded" width="36rem" height="3.2rem" />}
                            {!loading && identityProofError && (
                                <Typography>Erreur lors de la récupération des justificatifs d'indentité</Typography>
                            )}
                            {!loading && !identityProofError && (
                                <ButtonSelector
                                    type="default"
                                    placeholder="Choisissez un justificatif d'identité"
                                    value={field.value}
                                    label={field.value?.label ?? undefined}
                                    onChange={(identityProof) => {
                                        setValue('identityProof', identityProof, shouldDirty)
                                        onChange()
                                    }}
                                    options={documentsOption}
                                />
                            )}
                        </>
                    )}
                />
            )}
        />
    )
}

export default PatientIdentityDocument
